<section class="matching-results-container" *ngIf="matchResult; else noResults">
  <div class="card">
    <div class="card-header d-flex justify-content-between align-items-center flex-wrap gap-1">
      <h4 class="mb-0">Matching Results</h4>
      <div class="d-flex gap-1">
        <button class="btn btn-outline-primary mr-1" (click)="goBackToList()">Go to Student Pipelines</button>
        <button class="btn btn-outline-danger" (click)="clearResults()">Clear Results</button>
      </div>
    </div>
    <div class="card-body">
      <div class="row text-center">
        <div class="col-md-4 mb-2">
          <div class="result-stat success">
            <h5>Matched Pipelines</h5>
            <p class="stat-value">{{ matchResult?.matchedPipeline || 0 }}</p>
          </div>
        </div>
        <div class="col-md-4 mb-2">
          <div class="result-stat warn">
            <h5>Unmatched Pipelines</h5>
            <p class="stat-value">{{ matchResult?.unmatched || 0 }}</p>
          </div>
        </div>
        <div class="col-md-4 mb-2">
          <div class="result-stat info">
            <h5>Total Processed</h5>
            <p class="stat-value">{{ matchResult?.totalPipeline || 0 }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="match-cards mt-2" *ngIf="matchedRows.length">
    <div class="card mb-2 match-card" *ngFor="let item of matchedRows">
      <div class="card-header d-flex justify-content-between align-items-center">
        <div>
          <span class="badge badge-soft-primary mr-1">Match</span>
          <small class="text-muted">Pipeline #{{ item.pipelineData?._id || '—' }}</small>
        </div>
        <button
          class="btn btn-sm btn-outline-primary"
          (click)="confirmMerge(item)"
          [disabled]="isConfirming[item?.pipelineData?._id]"
        >
          <span *ngIf="!isConfirming[item?.pipelineData?._id]">Confirm Merge</span>
          <span *ngIf="isConfirming[item?.pipelineData?._id]">
            <i class="fa fa-spinner fa-spin"></i> Merging...
          </span>
        </button>
      </div>
      <div class="card-body match-card__body">
        <div class="match-card__panel student-panel">
          <div class="panel-title">Student</div>
          <div class="panel-name">{{ item.studentData?.name || 'N/A' }}</div>
          <div class="panel-meta">
            <span>{{ item.studentData?.email || item.studentData?.userData?.email || 'N/A' }}</span>
            <span>{{ item.studentData?.phone || item.studentData?.userData?.phone || 'N/A' }}</span>
          </div>
          <ul class="panel-list">
            <li>
              <label>College</label>
              <span>{{ item.studentData?.collage_id?.name || 'N/A' }}</span>
            </li>
            <li>
              <label>Notes</label>
              <span>{{ item.studentData?.notes || 'N/A' }}</span>
            </li>
          </ul>
        </div>
        <div class="match-card__divider">
          <span class="match-card__divider-icon">⇄</span>
          <small>Matched</small>
        </div>
        <div class="match-card__panel pipeline-panel">
          <div class="panel-title">Pipeline</div>
          <div class="panel-name">{{ item.pipelineData?.name || 'N/A' }}</div>
          <div class="panel-meta">
            <span>{{ item.pipelineData?.email || 'N/A' }}</span>
            <span>{{ item.pipelineData?.phone || 'N/A' }}</span>
          </div>
          <ul class="panel-list">
            <li>
              <label>College</label>
              <span>{{ item.pipelineData?.collage_id?.name || 'N/A' }}</span>
            </li>
            <li>
              <label>Notes</label>
              <span>{{ item.pipelineData?.notes || 'N/A' }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

<ng-template #noResults>
  <div class="card">
    <div class="card-body text-center">
      <h4>No saved matching results</h4>
      <p class="text-muted">Run the matching process from Student Pipelines to view results here.</p>
      <button class="btn btn-primary" (click)="goBackToList()">Go to Student Pipelines</button>
    </div>
  </div>
</ng-template>

